module.exports = __webpack_public_path__ + "img/cash-register-solid.06580e5d.svg";